// extracted by mini-css-extract-plugin
export default {"wraper":"src-components-Container-index-module_wraper--fOXqg","container":"src-components-Container-index-module_container--nROpf"};